import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/common/Header";
import WishlistHeader from "./components/WishlistHeader";
import WishlistProductCard from "./components/WishlistProductCard";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  getFavoraitesListService,
  toggleFavService,
} from "redux/services/general_service";
import Skeleton from "react-loading-skeleton";

const Wishlist = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [isAuthenticated] = useState(true); // Mock authentication state

  // Wishlist state
  const [wishlistItems, setWishlistItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // UI state
  const [viewMode, setViewMode] = useState("grid");
  const [isSelectionMode, setIsSelectionMode] = useState(false);
  const [selectedItems, setSelectedItems] = useState(new Set());
  const [isFiltersCollapsed, setIsFiltersCollapsed] = useState(true);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  // Filter state
  const [filters, setFilters] = useState({
    category: "all",
    priceRange: "all",
    availability: "all",
    sortBy: "newest",
  });

  // Initialize wishlist data
  useEffect(() => {
    const loadWishlist = async () => {
      setLoading(true);
      dispatch(getFavoraitesListService()).then((response) => {
        if (response.payload.status == 200) {
          setWishlistItems(response?.payload?.data?.data);
          setLoading(false);
        }
      });
    };

    if (isAuthenticated) {
      loadWishlist();
    } else {
      navigate("/user-authentication");
    }
  }, [isAuthenticated, navigate]);

  // Filter and sort items
  useEffect(() => {
    setFilteredItems([]);
  }, [wishlistItems, filters]);

  // Selection handlers
  const handleToggleSelection = (itemId) => {
    const newSelected = new Set(selectedItems);
    if (newSelected.has(itemId)) {
      newSelected.delete(itemId);
    } else {
      newSelected.add(itemId);
    }
    setSelectedItems(newSelected);
  };

  const handleSelectAll = () => {
    setSelectedItems(new Set(filteredItems.map((item) => item.id)));
  };

  const handleDeselectAll = () => {
    setSelectedItems(new Set());
  };

  const handleToggleSelectionMode = (id) => {
    setIsSelectionMode(!isSelectionMode);
    // dispatch(toggleFavService({product_id:id}))
    setIsSelectionMode(!isSelectionMode);
    if (isSelectionMode) {
      setSelectedItems(new Set());
    }
  };

  // Product actions
  const handleRemoveFromWishlist = async (itemId) => {
    dispatch(toggleFavService({ product_id: itemId })).then((response) => {
      if (response.payload.status == 200) {
        window.location.reload("");
      }
    });

    // Simulate API call
    /* await new Promise((resolve) => setTimeout(resolve, 500));
    setWishlistItems((prev) => prev.filter((item) => item.id !== itemId));
    setSelectedItems((prev) => {
      const newSelected = new Set(prev);
      newSelected.delete(itemId);
      return newSelected;
    });*/
  };

  const handleAddToCart = async (product) => {
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 800));
    console.log("Added to cart:", product.name);
    // Show success notification (would be implemented with a toast system)
  };

  const handleProductClick = (productId) => {
    console.log("Navigate to product:", productId);
    // navigate(`/products/${productId}`);
  };

  // Bulk actions
  const handleAddSelectedToCart = async () => {
    const selectedProducts = filteredItems.filter((item) =>
      selectedItems.has(item.id)
    );
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 1000));
    console.log("Added to cart:", selectedProducts.length, "items");
    setSelectedItems(new Set());
    setIsSelectionMode(false);
  };

  const handleRemoveSelected = async () => {
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 500));
    setWishlistItems((prev) =>
      prev.filter((item) => !selectedItems.has(item.id))
    );
    setSelectedItems(new Set());
    setIsSelectionMode(false);
  };

  const handleClearAll = async () => {
    if (
      window.confirm("Are you sure you want to clear your entire wishlist?")
    ) {
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 500));
      setWishlistItems([]);
      setSelectedItems(new Set());
      setIsSelectionMode(false);
    }
  };

  // Filter handlers
  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleClearFilters = () => {
    setFilters({
      category: "all",
      priceRange: "all",
      availability: "all",
      sortBy: "newest",
    });
  };

  const handleStartShopping = () => {
    navigate("/");
  };
  useEffect(() => {}, []);
  // Share functionality
  const wishlistUrl = `${window.location.origin}/wishlist/shared/user123`;

  if (loading) {
    return (
<div className="min-h-screen bg-background px-4 py-6">
  <Header />
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
    {Array.from({ length: 4 }).map((_, index) => (
      <div
        key={index}
        className="bg-white border border-gray-300 rounded-lg overflow-hidden shadow-lg"
      >
        <Skeleton height={200} />
        <div className="p-4">
          <Skeleton height={20} count={2} />
        </div>
      </div>
    ))}
  </div>
</div>

    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />

      {wishlistItems?.length === 0 ? (
        <div className="flex flex-col items-center justify-center mt-20">
          <img
            src="/assets/images/no_fav.jpg"
            alt="logo"
            className="w-80 h-80 object-cover rounded-lg"
          />
          <p
            className="mt-4 text-lg text-gray-700 font-semibold tracking-wide text-center leading-relaxed"
            style={{ fontFamily: "'Cairo', sans-serif" }}
          >
            {t("no_fav")}
          </p>
        </div>
      ) : (
        <>
          {/* Wishlist Header */}
          <WishlistHeader
            itemCount={wishlistItems?.length}
            viewMode={viewMode}
            onViewModeChange={setViewMode}
            isSelectionMode={isSelectionMode}
            onToggleSelectionMode={handleToggleSelectionMode}
            selectedCount={selectedItems.size}
            onClearAll={handleClearAll}
          />

          {/* Products Grid/List */}
          <div className="max-w-7xl mx-auto px-4 lg:px-6 py-8">
            {wishlistItems?.length === 0 ? (
              <div className="text-center py-12">
                <p className="text-text-secondary mb-4">
                  No items match your current filters.
                </p>
                <button
                  onClick={handleClearFilters}
                  className="text-primary hover:underline"
                >
                  Clear all filters
                </button>
              </div>
            ) : (
              <div
                className={`grid gap-6 ${
                  viewMode === "grid"
                    ? "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4"
                    : "grid-cols-1"
                }`}
              >
                {wishlistItems?.map((product) => (
                  <WishlistProductCard
                    key={product.id}
                    product={product}
                    viewMode={viewMode}
                    isSelectionMode={isSelectionMode}
                    isSelected={selectedItems.has(product.id)}
                    onToggleSelection={handleToggleSelection}
                    onRemoveFromWishlist={handleRemoveFromWishlist}
                    onAddToCart={handleAddToCart}
                    onProductClick={handleProductClick}
                  />
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Wishlist;
